export async function requestPayment(bookingDetails) {
    const response = await fetch("https://europe-west2-docs-n-data.cloudfunctions.net/theSmartWashStripeWebhook/v1/paymentRequest", {
        method: "POST",
        headers: {
            "content-type": "application/json",
        },
        body: JSON.stringify(bookingDetails)
    });
    if (!response.ok) {
        throw new Error(`Failed to request payment: ${await response.text()}`);
    }
}
